/* eslint-disable no-console */
const PRESS_TIMEOUT = 500

export function registerLongPressDirective(Vue) {
  Vue.directive('long-press', {
    bind: function (el, binding, vNode) {
      // Make sure expression provided is a function
      if (typeof binding.value !== 'function') {
        // Fetch name of component
        const compName = vNode.context.name
        // pass warning to console
        let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be`
        if (compName) {
          warn += `Found in component '${compName}' `
        }

        console.warn(warn)
      }

      // Define variable
      let pressTimer = null

      // Define function handlers
      // Create timeout ( run function after 1s )
      let start = (e) => {
        if (e.type === 'click' && e.button !== 0) {
          return
        }

        if (pressTimer === null) {
          pressTimer = setTimeout(() => {
            // Run function
            handler(e)
          }, PRESS_TIMEOUT)
        }
      }

      // Cancel Timeout
      let cancel = (e) => {
        // Check if timer has a value or not
        if (pressTimer !== null) {
          clearTimeout(pressTimer)
          pressTimer = null
          e.stopPropagation()
        }
      }
      // Run Function
      const handler = (e) => {
        binding.value(e)
      }

      // Mouse events
      el.addEventListener('mousedown', start)
      el.addEventListener('mouseup', cancel)
      el.addEventListener('mouseleave', cancel)
      el.addEventListener('mouseover', cancel)

      // Touch events
      el.addEventListener('touchstart', (e) => start(e))
      el.addEventListener('touchend', cancel)
      el.addEventListener('touchcancel', cancel)

      el.__longPress__ = { start, cancel }
    },
    unbind: function (el) {
      const { start, cancel } = el.__longPress__ || {}
      el.removeEventListener('mousedown', start)
      el.removeEventListener('mouseup', cancel)
      el.removeEventListener('mouseleave', cancel)
      el.removeEventListener('touchstart', start)
      el.removeEventListener('touchend', cancel)
      el.removeEventListener('touchcancel', cancel)
      delete el.__longPress__
    }
  })
}

/**
 * Long pressing elements may cause the click event to be triggered.
 * Need to manually suppress the click event
 * @param {Window} w
 */
export function blockClick(w) {
  const blockClick = (e) => {
    e.stopImmediatePropagation()
    e.preventDefault()
    w.removeEventListener('click', blockClick, true)
  }
  w.addEventListener('click', blockClick, true)
}
